import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes, c as clsx } from './p-50b8bf73.js';
import { n as nanoid } from './p-5959f2bd.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconCheckmarkStyle0 = stylesCss;

const BiIconCheckmark = /*@__PURE__*/ proxyCustomElement(class BiIconCheckmark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '9ce5cd45c55fc7218f222a5d4582af973ecd0d0b', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: 'e25577c44d972af9fa75079b10d17daeb74dc006', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '3aca42a000dadf5408fa35cf1b15cf3d79eab4ed', "fill-rule": 'evenodd', d: 'M9.868 16.994 20.82 6.041l1.061 1.061L9.868 19.116l-6.023-6.023 1.06-1.06z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconCheckmarkStyle0; }
}, [1, "bi-icon-checkmark", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-checkmark"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-checkmark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconCheckmark);
            }
            break;
    } });
}

export { BiIconCheckmark as B, defineCustomElement as d };
